import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Pluraliser extends Component {
    static propTypes = {
        text: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        tag: PropTypes.string,
        className: PropTypes.string
    }

    render() {
        var text = this.props.text;
        if (this.props.value !== 1) {
            if (text.endsWith('ty')) {
                text = text.substring(0, text.length - 1) + 'ies';
            } else {
                text += 's';
            }
        }
        const value = Number(this.props.value).toLocaleString();
        var Tag = this.props.tag;
        if (!Tag) {
            Tag = 'span';
        }
        return <Tag className={this.props.className}>{value} {text}</Tag>;
    }
}
